import React from 'react';
import moment from 'moment';
import { DataGridLayout, List, ListHeader, ListPageLayout } from 'framework/list';
import useGeneratedPayrollsService from 'domain/finance/payroll/generatedPayrolls/useGeneratedPayrollsService';
import ApprovePayrollReportButton from 'domain/finance/payroll/generatedPayrolls/shared/button/ApprovePayrollReportButton';
import MarkAsPaidPayrollReportButton from 'domain/finance/payroll/generatedPayrolls/shared/button/MarkAsPaidPayrollReportButton';
import { DATE_FORMAT } from 'framework/utils';
import GeneratedPayrollsStaticFilters from 'domain/finance/payroll/generatedPayrolls/List/GeneratedPayrollsStaticFilters';
import PayrollReportsStatusField from 'domain/finance/payroll/generatedPayrolls/shared/field/PayrollReportsStatusField';
import PayrollReportsOfficeField from 'domain/finance/payroll/generatedPayrolls/shared/field/PayrollReportsOfficeField';
import { TextField } from 'framework/ui/field';
import { CreateButton } from 'framework/ui/ui-builder';
import { usePayrollUrl } from 'domain/finance/payroll/route';
import { EmployeeLinkFieldWithNameLoading } from 'domain/shared/employee';
import RejectPayrollReportButton from 'domain/finance/payroll/generatedPayrolls/shared/button/RejectPayrollReportButton';
import CancelPayrollReportPaymentButton from 'domain/finance/payroll/generatedPayrolls/shared/button/CancelPayrollReportPaymentButton';

const CancelButtons = () => (
  <>
    <CancelPayrollReportPaymentButton statusSource="status" />
    <RejectPayrollReportButton statusSource="status" />
  </>
);

const GeneratedPayrollListPage = () => {
  const { getListUrl } = usePayrollUrl();
  const { getGeneratedReports } = useGeneratedPayrollsService();
  const currentMonthStart = moment().startOf('month').format(DATE_FORMAT.API_ONLY_DATE);
  const currentMonthEnd = moment().endOf('month').format(DATE_FORMAT.API_ONLY_DATE);

  return (
    <List
      getDataMethod={getGeneratedReports}
      defaultFilter={{
        period: {
          ge: currentMonthStart,
          le: currentMonthEnd,
        },
      }}
    >
      <ListPageLayout
        header={<GeneratedPayrollsStaticFilters title={<ListHeader label="Payroll Reports" />} />}
        actions={[<CreateButton url={getListUrl()} label="Generate" />]}
      >
        <DataGridLayout
          buttons={[
            <ApprovePayrollReportButton statusSource="status" />,
            <MarkAsPaidPayrollReportButton statusSource="status" />,
            <CancelButtons />,
          ]}
          sxTableWrapper={{
            '& table.MuiTable-root': {
              minWidth: '1080px',
              '& th:nth-last-child(2)': {
                width: '120px',
              },
              '& th:nth-last-child(3)': {
                width: '100px',
              },
              '& th:last-child': {
                width: '140px',
              },
            },
          }}
        >
          <TextField source="id" label="ID" width="22%" />
          <TextField source="period" />
          <PayrollReportsStatusField source="status" />
          <PayrollReportsOfficeField source="offices" />
          <EmployeeLinkFieldWithNameLoading source="approvedBy" label="Approved by" />
          <EmployeeLinkFieldWithNameLoading source="markedAsPaidBy" label="Marked as paid by" />
        </DataGridLayout>
      </ListPageLayout>
    </List>
  );
};

export default GeneratedPayrollListPage;
